import React from "react";
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Chip,
  Container,
} from "@mui/material";

const gold = "#C29D59";
const darkBg = "#111";

const blogs = [
  {
    title: "Functional Design Trends That Blend Style And Comfort",
    category: "Power Tools",
    date: "June 2, 2025",
    author: "Admin",
    image: "/images/blog-a.jpg",
    description:
      "Modern interior design is all about creating a sleek, functional, and aesthetically pleasing space that reflects contemporary living.",
  },
  {
    title: "Innovative Interior Ideas To Refresh Your Living Space",
    category: "Electrical & Lighting",
    date: "June 2, 2025",
    author: "Admin",
    image: "/images/blog-b.jpg",
    description:
      "Modern interior design is all about creating a sleek, functional, and aesthetically pleasing space that reflects contemporary living.",
  },
  {
    title: "Transform Your Home With The Modern Interior Design",
    category: "Accessories",
    date: "June 2, 2025",
    author: "Admin",
    image: "/images/blog-c.jpg",
    description:
      "Modern interior design is all about creating a sleek, functional, and aesthetically pleasing space that reflects contemporary living.",
  },
  {
    title: "Creative Lighting Ideas For Modern Interiors",
    category: "Lighting",
    date: "June 2, 2025",
    author: "Admin",
    image: "/images/interior-d.jpg",
    description:
      "Lighting plays a vital role in interior design, creating mood, highlighting features, and adding depth to any space.",
  },
];

const BlogSection = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        maxWidth: "1450px !important",
        mx: "auto",
        px: { xs: 2, md: 4 },
        py: { xs: 6, md: 10 },
      }}
    >
      {/* Section Header */}
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: gold,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 1,
            mb: 2,
          }}
        >
          Blogs
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: "#fff",
            mb: 2,
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.8rem" },
          }}
        >
          Our Latest Blog{" "}
          <Box component="span" sx={{ color: gold }}>
            & Articles.
          </Box>
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: 700,
            mx: "auto",
            mb: 8,
            color: "rgba(255,255,255,0.7)",
            lineHeight: 1.7,
            fontSize: { xs: "0.9rem", sm: "1rem" },
          }}
        >
          Discover the latest design ideas, smart home innovations, and creative
          trends redefining modern interiors. From cozy spaces to luxurious
          transformations.
        </Typography>
      </Box>

      {/* Blog Layout */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: "30px", md: "40px" },
          padding: "10px",
        }}
      >
        {/* Left Featured Blog */}
        <Box
          sx={{
            width: { xs: "100%", md: "49%" },
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            backgroundColor: "rgba(255,255,255,0.05)",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <CardMedia
              component="img"
              height="400"
              image={blogs[0].image}
              alt={blogs[0].title}
              sx={{
                objectFit: "cover",
                width: "100%",
                height: { xs: 250, sm: 300, md: 400 },
              }}
            />
            <Chip
              label={blogs[0].category}
              sx={{
                position: "absolute",
                top: 20,
                left: 20,
                backgroundColor: gold,
                color: "white",
                fontSize: "12px",
              }}
            />
          </Box>
          <CardContent>
            <Typography variant="body2" color="#fff" sx={{ mb: 1 }}>
              By{" "}
              <Box component="span" sx={{ color: gold }}>
                {blogs[0].author}
              </Box>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                lineHeight: 1.3,
                color: "#fff",
                fontSize: { xs: "1.2rem", sm: "1.4rem" },
              }}
            >
              {blogs[0].title}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mt: 1,
                lineHeight: 1.6,
                color: "#b0b0b0ff",
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              {blogs[0].description}
            </Typography>
          </CardContent>
        </Box>

        {/* Right Side Blogs */}
        <Box
          sx={{
            width: { xs: "100%", md: "49%" },
            display: "flex",
            flexDirection: "column",
            gap: { xs: "15px", sm: "20px" },
          }}
        >
          {blogs.slice(1).map((blog, index) => (
            <Card
              key={index}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                borderRadius: 3,
                background: "none",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              }}
            >
              {/* Image */}
              <Box
                sx={{
                  position: "relative",
                  flex: { xs: "0 0 auto", sm: "0 0 45%" },
                  borderRadius: 4,
                  overflow: "hidden",
                }}
              >
                <CardMedia
                  component="img"
                  image={blog.image}
                  alt={blog.title}
                  sx={{
                    objectFit: "cover",
                    height: { xs: 200, sm: 180 },
                    width: "100%",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.5))",
                  }}
                />
                <Chip
                  label={blog.category}
                  sx={{
                    position: "absolute",
                    top: 10,
                    left: 10,
                    backgroundColor: gold,
                    color: "white",
                    fontSize: "12px",
                    zIndex: 2,
                  }}
                />
              </Box>

              {/* Content */}
              <CardContent sx={{ flex: "1 1 auto", padding: "16px" }}>
                <Typography variant="body2" color="#fff" sx={{ mb: 0.5 }}>
                  {blog.date} • By{" "}
                  <Box component="span" sx={{ color: gold }}>
                    {blogs[0].author}
                  </Box>
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    lineHeight: 1.4,
                    color: "#fff",
                    fontSize: { xs: "1rem", sm: "1.1rem" },
                  }}
                >
                  {blog.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    mt: 0.5,
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    color: "#b0b0b0ff",
                    fontSize: { xs: "0.85rem", sm: "0.9rem" },
                  }}
                >
                  {blog.description}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default BlogSection;
